import { httpClient } from 'utils/httpClient';
import { ExoneracionResponse, ExoneracionPayload } from 'types/exoneracion.types';

export const exoneracionService = {

  // Modo 1: exoneraciones de un estudiante  → ?matriculaId=
  // Modo 2: todos los exonerados de un curso → ?cursoId=&anioEscolarId=
  async listar(params: { matriculaId?: number; cursoId?: number; anioEscolarId?: number }): Promise<ExoneracionResponse[]> {
    const q = new URLSearchParams();
    if (params.matriculaId)   q.set('matriculaId',   String(params.matriculaId));
    if (params.cursoId)       q.set('cursoId',        String(params.cursoId));
    if (params.anioEscolarId) q.set('anioEscolarId',  String(params.anioEscolarId));
    return httpClient.get<ExoneracionResponse[]>(`/exoneraciones?${q}`);
  },

  async crear(payload: ExoneracionPayload): Promise<ExoneracionResponse> {
    return httpClient.post<ExoneracionResponse>('/exoneraciones', payload);
  },

  // Soft delete — la exoneración queda inactiva
  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/exoneraciones/${id}`);
  },
};
